<template>
  <date-field ref="SALARIE_DATE_NAISSANCE"
              :value=value
              :contextId=contextId
              :editFieldInfo=editFieldInfo
              :periods=periods
              :hideLabel='hideLabel'
              :dataTable='dataTable'
              :required=required
              :disabled=readOnly
              :showMissing=showMissing
              :over-ride-placeholder=overRidePlaceholder
              @updated=setUpdated
              @context=setInitValue
              @error=setError>
  </date-field>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EditBase from '@/framework/base/components/EditBase';
  import DateField from '@/framework/base/components/DateField.vue'
  import { EditFieldType, FieldInfo, getFormat } from '@/framework/base/components/FieldInfo'
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';
  // eslint-disable-next-line
  import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';

  export default defineComponent({
    extends: EditBase,
    components: {
      DateField
    },
    props: {
      overRidePlaceholder: {
        type: String
      }
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.SALARIE_DATE_NAISSANCE); },
      editFieldInfo (): FieldInfo {
        const type = EditFieldType.DATE;
        const precision = 2;
        const format = getFormat('');
        const focus = this.focusValidator;
        const live = this.liveValidator;
        const mask = this.mask;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
      }
    },
    methods: {
      // eslint-disable-next-line
      focusValidator (value: string): validator | null {
        return  new validator(rules.dateFormatValid, RULES_FRENCH_LABEL.text.dateFormatValid.error);
      },

      // eslint-disable-next-line
      liveValidator (value: string): validator | null {
        return null;
      },

      // eslint-disable-next-line
      mask (value: string): string {
        return 'NN/NN/NNNN';
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.SALARIE_DATE_NAISSANCE.missing();
      },

      touch (): void {
        // @ts-expect-error : generated method
        this.$refs.SALARIE_DATE_NAISSANCE.touch();
      },

      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.SALARIE_DATE_NAISSANCE.setFocus();
      }
    }
  })
</script>
